import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";
import LoginPage from "./Pages/LoginPage";
import Process from "./Pages/Process";
import Unauthorized from "./Pages/unauth";
import FormSubmitted from "./Pages/formSubmitted";
import ConsentForms from "./Pages/Forms/Patient Registration Forms/Consent";
import ExistingPatientRegistrationForms from "./Pages/Forms/Patient Registration Forms/ExistingPatReg";
import PatientRegistrationForms from "./Pages/Forms/Patient Registration Forms/newPatientReg";
import ContextNotFound from "./Pages/ContextNotFound";
import NotFound from "./Pages/notFound"
import { ZoomProvider } from "./Context/Zoom";
import ErrorBoundary from "./Components/ErrorBoundary";


const SentryRoutes = Sentry.withSentryRouting(Routes);

const App = () => {
  return (
      <ErrorBoundary>
      <ZoomProvider>
      <Router>
      <SentryRoutes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/unauth" element={<Unauthorized />} />
          <Route path="/process" element={<Process />} />
          <Route path="/form-submission-success" element={<FormSubmitted />} />
          <Route path="/context-not-found" element={<ContextNotFound />} />
          <Route path="/existing-patient-registration-form" element={<ExistingPatientRegistrationForms />} />
          <Route path="/patient-registration-form" element={<PatientRegistrationForms />} />
          <Route path="/consent" element={<ConsentForms />} />
          <Route path="*" element={<NotFound />} />
        </SentryRoutes>
      </Router>
      </ZoomProvider>
      </ErrorBoundary>
  );
};

export default App;
